module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 420
// module chunks = 0